export default {
    // ker smo v CoachForm shranili podatke v keys firs, last, desc kateri niso isti kot firstName, lastName v index.js 
    // jih transformiramo v actions.js
    registerCoach(state, payload) {
        state.coaches.push(payload)
    }
};